// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resp_tel_inp_width[data-v-45150d44]{width:96%!important}.pos_rel_5[data-v-45150d44]{position:relative;left:-5px!important}@media (min-width:750px){.pos_rel_5[data-v-45150d44]{position:relative;left:-22px!important}}@media (max-width:550px){.pos_rel_5[data-v-45150d44]{position:relative;left:-12px!important}}@media (max-width:300px){.pos_rel_5[data-v-45150d44]{position:relative;left:0!important}}", ""]);
// Exports
module.exports = exports;
